import { useInViewport, useMemoizedFn } from 'ahooks';
import { memo, useEffect, useMemo, useRef } from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  useDisclosure,
} from '@heroui/react';
import isEqual from 'react-fast-compare';
import dayjs from 'dayjs';
import { getWeekdays } from '@/utils/dayjs.js';

export const formattedDayTitleDate = (date: string) => {
  const currentTime = dayjs(date);
  return `${currentTime.format('MM.DD')} 周${getWeekdays(currentTime.day())}`;
};

const DayTitle = memo(
  ({
    date,
    onAddOpen,
  }: {
    date: string;
    onAddOpen?: (payload?: { isAppend?: boolean }) => void;
    id: string;
  }) => {
    const formattedDate = useMemo(() => {
      return formattedDayTitleDate(date);
    }, [date]);

    return (
      <Dropdown>
        <DropdownTrigger>
          <header className='pt-3 pb-2 px-5 h-[56px] transition-transform origin-left'>
            <b className=' text-3xl'>{formattedDate}</b>
          </header>
        </DropdownTrigger>
        {/* @ts-ignore type */}
        <DropdownMenu
          onAction={(key: string) => {
            if (key === 'add') {
              onAddOpen?.();
            } else if (key === 'addAppend') {
              onAddOpen?.({ isAppend: true });
            }
          }}
          variant='flat'
        >
          <DropdownItem key='add'>追加活动</DropdownItem>
          <DropdownItem key='addAppend'>前置活动</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  },
  isEqual
);

export default DayTitle;
